import React from "react";
import { MdArrowBackIosNew, MdArrowForwardIos } from "react-icons/md";
import { RxHamburgerMenu } from "react-icons/rx";

const Sidebar = ({ setActiveTab }) => {
  function showSidebar() {
    const sidebar = document.querySelector(".sidebar");
    sidebar.classList.add('active')
  }

  function hideSidebar() {
    const sidebar = document.querySelector(".sidebar");
    sidebar.classList.remove('active')
  }
  return (
    <>
      <div style={styles.sidebar} className="sidebar">
        <div className="title_hamburger_div">
          <h2 style={styles.h2}>Admin Dashboard</h2>
          <div className="sidebar_hamburger">
            {/* <MdArrowBackIosNew className="icon" onClick={hideSidebar} /> */}
            <span className="icon" onClick={hideSidebar}>X</span>
          </div>
        </div>
        <ul style={styles.ul}>
          <li style={styles.li} onClick={() => setActiveTab("add-painting")}>
            <span onClick={hideSidebar}>
              Add Paintings
            </span>
          </li>
          <li style={styles.li} onClick={() => setActiveTab("my-paintings")}>
            <span onClick={hideSidebar}>
              My Paintings
            </span>
          </li>
          <li style={styles.li} onClick={() => setActiveTab("orders")}>
            <span onClick={hideSidebar}>
              My Orders
            </span>
          </li>
          <li style={styles.li} onClick={() => setActiveTab("profile")}>
            <span onClick={hideSidebar}>
              My Profile
            </span>
          </li>
          <li style={styles.li} onClick={() => setActiveTab("logout")}>
            <span onClick={hideSidebar}>
              Logout
            </span>
          </li>
        </ul>
      </div>
      <div className="sidebar_hamburger">
        <RxHamburgerMenu className="icon" onClick={showSidebar} />
      </div>
    </>
  );
};

const styles = {
  sidebar: {
    width: "250px",
    height: "100%",
    backgroundColor: "#000",
    padding: "10px 20px",
    boxShadow: "2px 0 5px rgba(0, 0, 0, 0.1)",
    zIndex: '1000'
  },
  h2: {
    fontSize: "22px",
    // marginTop: "70px", 
    color: "#cc9051",
    marginBottom: "20px",
  },
  ul: {
    listStyleType: "none",
    padding: 0,
  },
  li: {
    marginTop: "10px",
    marginBottom: '30px',
    cursor: "pointer",
    textDecoration: "none",
    color: "#cc9051",
    fontSize: "18px",
    fontWeight: 500,
  },
};

export default Sidebar;
